export default "__VITE_ASSET__af43c19d__"